/* lazyload.js (c) Lorenzo Giuliani
 * MIT License (http://www.opensource.org/licenses/mit-license.html)
 *
 * expects a list of:
 * `<img src="blank.gif" data-src="my_image.png" width="600" height="400" class="lazy">`
 */

OT.createNS('OT.Common.LazyLoadImages');

OT.Common.LazyLoadImages = (function () {
    'use strict';

    var images;

    var reset = function() {
        images = [];
    };

    var loadImage = function(imgEl, fn) {
        var img = new Image();
        var src = imgEl.getAttribute('data-src');

        var hasMobileVersion = imgEl.getAttribute('data-src-mobile');

        // If on a mobile and it has a mobile source, then use that
        if(!!hasMobileVersion && window.innerWidth < imgEl.getAttribute('data-mobile-size')) {
            src = imgEl.getAttribute('data-src-mobile');
        }

        img.onload = function() {
            if (!!imgEl.parent) {
                imgEl.parent.replaceChild(img, imgEl);
            } else {
                imgEl.src = src;
            }

            if(imgEl.className.indexOf('loaded') === -1) {
                imgEl.className += ' loaded';
            }

            if(fn) {
                fn();
            }
        };

        img.src = src;
    };

    var elementInViewport = function (imgEl, threshold) {
        threshold = threshold || 0;
        var rect = imgEl.getBoundingClientRect();

        return (rect.top >= 0 && rect.left >= 0 && rect.top <= threshold + (window.innerHeight || document.documentElement.clientHeight));
    };

    var processScroll = function() {
        for (var i = 0; i < images.length; i++) {
            if (!images[i].processed) {
                var elem = images[i].elem;
                if (elementInViewport(elem, 200)) {
                    images[i].processed = true;
                    loadImage(images[i].elem);
                }
            }
        }
    };

    var findImages = function() {
        var i     = 0,
            query = $('img.lazy'),
            len   = query.length;

        for (i; i < len; i++) {
            images.push({elem:query[i], processed:false});
        }
    };

    var init = function() {
        reset();
        findImages();
        processScroll();
        OT.Events.on('scroll:stop', processScroll);
        OT.Events.on('scroll:throttled', processScroll);
    };

    var loadAll = function() {
        reset();

        var i     = 0,
            query = $('img.lazy'),
            len   = query.length;

        for (i; i < len; i++) {
            loadImage(query[i]);
        }
    };

    return {
        init: init,
        loadAll: loadAll,
        elementInViewport: elementInViewport
    };

})();
